import React, { useEffect, useState } from 'react'
import {
  Layout, Menu, Tag, Space,
} from 'antd'
import { UserOutlined, LogoutOutlined } from '@ant-design/icons'
import {
  Link, Route, Switch, useLocation, useHistory, Redirect,
} from 'react-router-dom'
import { useRecoilState } from 'recoil'
import Cookies from 'js-cookie'
import ReactCountryFlag from 'react-country-flag'

import routes from '../../config/routes'
import { userState } from '../../store'

const { SubMenu } = Menu
const {
  Header, Sider, Content, Footer,
} = Layout

const LayoutPage = () => {
  const [collapsed, setCollapsed] = useState(null)
  const [loading, setLoading] = useState(true)
  const [openKey, setOpenKey] = useState([])
  const [selectedKey, setSelectedKey] = useState([])
  const [user, setUser] = useRecoilState(userState)
  const location = useLocation()
  const history = useHistory()

  const paths = routes(user?.role.length > 0 && user.role).map((route) => {
    const generateRegex = (path) => {
      const regexp = path.split('/').map((p) => {
        if (p.startsWith(':')) return '\\S+'
        return p
      }).join('/')
      return new RegExp(`${regexp}$`, 'g')
    }
    const build = (p) => ({ path: p.path, render: p.route.component, regex: generateRegex(p.path) })

    if (route.type === 'subMenu') { return route.children.map((children) => ({ ...build(children), parent: route.key })) } return build(route)
  }).flat(1)

  const toggle = () => {
    setCollapsed(!collapsed)
  }

  const onLogout = () => {
    Cookies.remove(`oms-token-${process.env.REACT_APP_ENV}`)
    setUser({})
    history.push('/')
    window.location.reload()
  }

  useEffect(() => {
    console.log('path', paths, location.pathname)
    const [currentPath] = paths.filter((p) => p.regex && p.regex.test(location.pathname))
    if (currentPath) {
      setOpenKey([currentPath.parent])
      setSelectedKey([currentPath.path])
    }
    setLoading(false)
  }, [location.pathname])

  const findMenuItemId = (path) => {
    const pathStr = path.split('/')
    const str = pathStr.filter((s) => s)
    let id = 'none'
    str.map((s, index) => {
      if (index === 0) {
        id = s
      } else {
        id += ('-' + s)
      }
      return s
    })
    return id
  }

  const renderMenu = (route) => {
    const id = findMenuItemId(route.path)
    return <Menu.Item id={id} key={route.path} icon={route.menu.icon}>
      <Link to={route.path}>{route.menu.render}</Link>
    </Menu.Item>
  }

  if (loading) return '...'

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={toggle}>
        <div
          className="logo"
          style={{
            height: 32,
            margin: 16,
            color: 'white',
            fontSize: 24,
            fontWeight: 500,
          }}
        >OMS
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={selectedKey}
          defaultOpenKeys={openKey}
        >
          {
            routes(user?.role.length > 0 && user.role).map((route) => {
              if (route.type === 'subMenu') {
                return (
                  <SubMenu key={route.key} icon={route.menu.icon} title={route.menu.render}>
                    {route.children.filter((r) => r.type === 'menu').map((r) => renderMenu(r))}
                  </SubMenu>
                )
              }
              if (route.type === 'menu') return renderMenu(route)
              return (<></>)
            })
          }

        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header className="site-layout-background" style={{ padding: 0, background: '#fff' }}>
          <Menu mode="horizontal" style={{ float: 'right' }}>
            <SubMenu key="user" icon={<UserOutlined />} title={user?.username}>
              <Menu.Item style={{ height: 'auto' }}>
                <div>
                  <Space>
                    {user?.siteCode && <Tag>Site: {user?.siteCode}</Tag>}
                    {user?.country?.code
                      && (
                        <Tag icon={(
                          <ReactCountryFlag
                            style={{ border: '0.5px solid black' }}
                            countryCode={user?.country?.code}
                            svg
                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                            cdnSuffix="svg"
                          // title={user?.country?.code}
                          />
                        )}
                        >
                          &nbsp;{user?.country?.code}
                        </Tag>
                      )}
                  </Space>
                </div>
                <div>{user?.roleDescr.length > 0 && user.roleDescr.map((item) => <Tag key={item}>{item}</Tag>)}</div>
              </Menu.Item>
              <Menu.Divider />
              <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={onLogout}>Logout</Menu.Item>
            </SubMenu>
          </Menu>
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: '#fff',
          }}
        >
          <Switch>
            {paths.map((p) => <Route exact path={p.path} render={p.render} />)}
            <Redirect from="*" to="/order" />
          </Switch>
        </Content>
        <Footer style={{ textAlign: 'center' }}>Order Management System © Index Livingmall 2020 Version 0.1.5</Footer>
      </Layout>
    </Layout>
  )
}

export default LayoutPage
